import React, { Component } from 'react'
import config from '../config'
import '../stylesheets/products.sass'
import { withRouter, Link } from 'react-router-dom'
import { checkRole, roleCanView } from '../InternalNavigation/roles'

class Product extends Component {
  render () {
    let product = this.props.product
      && this.props.product['attributes']

    return checkRole('admin', this.props.role)
      ? <div>
          <Link to={{ pathname: '/product', state: { product: this.props.product } }}>
            <div className={'product-card'}>
              <img
                className={'product-image'}
                width={'105'} height={'105'}
                alt={`${product['name']}`}
                src={`${product['imageUrl']}`} />
              <div className={'product'}>
                {product['name']}
              </div>
            </div>
          </Link>
        </div>
      : <div>
          <div className={'product-card'}>
            <img
              className={'product-image'}
              width={'105'} height={'105'}
              alt={`${product['name']}`}
              src={`${product['imageUrl']}`} />
            <div className={'product'}>
              {product['name']}
            </div>
          </div>
        </div>
  }
}

export default withRouter(Product)



// WEBPACK FOOTER //
// ./src/Products/product.jsx